var render, staticRenderFns
import script from "./BeforeListContent.vue?vue&type=script&lang=js"
export * from "./BeforeListContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c58b245",
  null
  
)

export default component.exports